<template>
  <div>
    <div v-loading="BOMloading" @drop="onDrop" @dragover.prevent>
      <!-- 表格区域 -->
      <vxe-grid ref="xGrid" :scroll-y="{ enabled: true }" v-bind="gridOptions" class="mytable-style"
        :cell-class-name="cellClassName" @edit-disabled="editDisabledEvent" @cell-dblclick="noEdit"
        @custom='customEvent' @edit-actived="editActivedEvent" @checkbox-all="checkboxChangeEvent"
        @checkbox-change="checkboxChangeEvent" :checkbox-config="{ checkMethod: checkboxMethod, checkStrictly: false }"
        :cell-style="{ padding: '3px', 'font-size': '12px', 'line-height': '16px ' }">
        <template #toolbar_buttons>
          <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="searchAddBom = true"
            :disabled="!editTable || !addTableListPriv">{{ $t("message.button.add")
            }}</el-button>
          <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox"
            :disabled="!editTable || !removeBtnPriv">{{
  $t("message.button.delete") }}</el-button>
          <el-button class="btn btn3" icon="el-icon-download" @click="exportBOM" :disabled="!exportBtnPriv">{{
            $t("message.button.export") }}</el-button>
          <el-button class="btn btn6" icon="el-icon-d-caret" @click="expandAll" v-show="!switchValue"> {{
            $t("message.button.expandAll")
          }} </el-button>
          <el-button class="btn btn7" icon="el-icon-document-checked" @click="getUpdateEvent" v-if="!editShow"
            :disabled="!pageChanged || (!editTable || !addTableListPriv)">{{
              $t("message.button.save") }}</el-button>
          <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave" v-if="!editShow"
            :disabled="!editTable || !addTableListPriv">{{
              $t("message.button.cancel") }}</el-button>
          <el-button class="btn btn4" icon="el-icon-document-copy" @click="BOMCopy" v-if="BOMList">{{
            $t("message.button.copyBOM") }}</el-button>
          <el-button class="btn btn5" icon="el-icon-document-copy" v-show="showButton" @click="getBOMList(0)">{{
            $t('message.title.BOMGather') }}</el-button>
          <el-button class="btn btn6" icon="el-icon-document-copy" v-show="showButton" @click="getBOMList(1)">{{
            $t('message.title.PurchaseList') }}</el-button>
          <!-- <el-button class="btn btn7" icon="el-icon-document-copy" @click="setAlt">
            添加替代料</el-button> -->

          <!-- <el-button v-for="item in buttonList" :key="item.icon"></el-button> -->

          <el-switch style="margin-left:45px" v-model="switchValue" v-show="switchShow" active-color="#13ce66"
            :active-text="redLine" @change="redLineSwitch" />
        </template>

        <!-- <template #getDynamicList="{ row,columnIndex,column}">
          <span v-for="item in getDynamicListShow(row,columnIndex-1,column)" style="margin-right: 3px;" :class="{'showLink':item.link}" :key="item.index" @click="clax(item)"> {{ item.title +',' }}</span>
        </template> -->

        <template #getDynamic="{ row, columnIndex, column }">
          <span v-for="(item, index) in getDynamicData(row, columnIndex - 1, column)" class="showLink" :key="index"
            :title="item.label" @click="clax(item)"> {{ item.label }}</span>
        </template>

        <template #bottom>
          <div class="alert-message">
            <span class="alert-message-content">
              <div> {{ $t('message.title.Checked') + selectRecords.length }} {{ $t('message.title.totalResults') +
                totalRecords + $t('message.title.resultsNums') }}</div>
            </span>
          </div>
        </template>
      </vxe-grid>
    </div>

    <el-dialog v-dialogDrag v-if="searchAddBom" width='65%' class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="searchAddBom" :close-on-click-modal="!searchAddBom" :close-on-press-escape="false">
      <searchAdd @listDbClick="addList" :creatBy='creatBy' :departmentList='departmentList'>
        <div>
          <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="addM">{{ $t("message.title.create")
          }}</el-button>
        </div>
      </searchAdd>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="creatNew" class="searchAddBomList" :title="$t('message.title.create')"
      :visible.sync="creatNew" :close-on-click-modal="!creatNew">
      <!-- <searchAdd @listDbClick="addList"></searchAdd> -->
      <Create :saveUrl="saveTableUrl" :baseClass="baseClass_" :creatBy='creatBy' :departmentList='departmentList'
        :classId_="createClassId" @addToList="creatNewModel" @closeCreateNew="closeCreateNew"></Create>
    </el-dialog>
    <el-dialog v-dialogDrag v-if="cascaderShow" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="cascaderShow" @close="closeCascaderShow">
      <div style="height:270px;">
        <div style="margin:60px auto;padding-left:50px">
          <el-cascader v-model="cascaderValue" :options="cascaderList" :props="cascaderProps" :show-all-levels="true"
            size="small" ref="cascaderAddr" style="width:75%"></el-cascader>
          <el-button size="small" type="primary" style="margin-left:10px" @click="getCascadeValue">{{
            $t("message.button.affirm") }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="copyBOM" :title="BOMTitle" :visible.sync="copyBOM" width="80%" @close="closeBOMList">

      <BOM-list :baseGridOptions='gridOptions' :BOMType='BOMType' v-if='BOMListShow' />
      <copy-BOM v-else :baseGridOptions='gridOptions' />
    </el-dialog>

    <el-dialog v-dialogDrag v-if="getAlt" :title="BOMTitle" :visible.sync="getAlt" width="60%" @close="closeBOMList">
      <Alternative :majorInfo="majorInfo" @setAlteData="setAlteData" />
    </el-dialog>
  </div>
</template>


<script>
import searchAdd from "@/components/searchAdd.vue";
import Alternative from "./Alternative.vue";
import axios from "axios";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import Create from "@/components/common/Create.vue";
import CopyBOM from './copyBOM.vue'
import BOMList from './BOMList.vue';
import { dialogDrag } from '@/utils/directive'
import { mapState, mapMutations } from 'vuex';
import { getNewTableContentData, getNewTableTitleData, setListEntry } from "@/utils/index";
import { getNewRedLineTableContentData, } from "../change/changeAI/affectItemConfig";


import { formatData } from './BOM_Methods'

import { LINK_LIST } from "@/utils/constants";


import Vue from "vue";
import BOM_Methods from "./BOM_Methods";
Vue.directive('dialogDrag', dialogDrag);

export default {
  name: "BOM",
  data() {
    return {

      exportDataTemp: [],//存放导出的BOM，里面的multilist以text形式存值

      searchAddBom: false, //添加窗口开关
      oldTableValue: {},
      version: "",
      redLine: '',

      majorInfo: {},

      BOMListShow: false,
      BOMList: false,
      BOMType: '',

      titleList: [
        {
          id: 0,
          title: this.$t('message.title.BOMGather')
        },
        {
          id: 1,
          title: this.$t('message.title.PurchaseList')
        },
        {
          id: 3,
          title: this.$t('message.button.copyBOM')
        }
      ],
      BOMTitle: '',

      redLineTypeList: [
        { id: 1, label: this.$t('message.title.add') },
        { id: 2, label: this.$t('message.title.delete') },
        { id: 3, label: this.$t('message.title.add') },
        { id: 4, label: '' },
      ],

      dataLink: "",
      createClassId: "10101",
      creatBy: 'BOM',
      baseClass_: "101",
      saveTableUrl: "/pmdm/items/saveItemP1P2P3",
      creatNew: false,

      BOMloading: false,
      selectRecords: [],
      totalRecords: "",
      gridOptions: {
        toolbarConfig: {
          zoom: true,
          custom: true,
          slots: {
            buttons: "toolbar_buttons",
          },
        },
        keepSource: true,
        resizable: true,
        border: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "600",
        size: "small",
        columns: [
          {
            type: "checkbox",
            width: 50,
            fixed: null,
          },
        ],
        data: [],
        customConfig: {

        },
        treeConfig: {
          lazy: true,
          children: "children",
          hasChild: "hasChildren",
          loadMethod: this.loadChildrenMethod,
        },
        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
        editRules: {},
      },
      editShow: false,
      leftShow: true,
      showBtn: false,
      editTable: true,
      scroll_top: 1,

      loading: true,
      cols: [], //表头
      rols: [], //表体所有内容
      rols_text: [], //表体显示内容
      rols_text_All: [],//表格所有数据
      tableDataOver: false,//表格是否全部加载完
      tableShow: false, //显示table
      get_change_info: "", //父组件传来的值
      select_list: {},
      childsTable: [], //子列表集合
      childsIndex: [], //子列表index集合
      exportedBom: [], //导出的数据

      removeBtnPriv: false, //删除按钮权限
      exportBtnPriv: false, //导出按钮权限
      addTableListPriv: false,

      pageIndex: 2,
      dataComplete: false,
      finished: false,

      copyBOM: false,
      // itemTabInfo:this.tabInfo,

      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {},
      smallWidthIds: [1003003, 1003006, 1003007, 1003008],

      BOMsTableId: 0,
      seekId: '',
      seekColumns: '',
      hasEdited: false,
      componentname: this.$route.matched[1].path.slice(1),

      // switchValue:true,
      switchValue: false,
      objId: {
        ... this.$store.state.objectId,
      },
      changeObjId: {
        changeId: this.$store.state.objectId.id,
        changeClassId: this.$store.state.objectId.classId,
        changeSubClassId: this.$store.state.objectId.subClassId,
      },
      getAlt: false
    };

  },

  mounted() { },
  components: {
    searchAdd,
    Create,
    CopyBOM,
    BOMList,
    Alternative
  },
  computed: {
    switchShow() {
      // return ![10401,10402].includes(this.$store.state.classId_)
      return !!this.$store.state.change_info.changeId;
    },
    showButton() {
      return this.$store.state.boms_table_id == 4;
    },
    itemTabInfo: function () {
      return this.tabInfo // 直接监听props里的tabInfo状态
      //  console.log(this.tabInfo);
    },
    ...mapState({
      pageChanged: (state) => state.pageChanged
    })
  },
  props: ["changInfoNum", 'tabInfo'],
  methods: {
    onDrop(event) {
      if (!this.editTable || !this.addTableListPriv) {
        return;
      }

      const fieldData = this.$store.state.dragMenu;
      const query = this.$route.query;
      const classId = Number(query.classId.toString().slice(0, 3));
      if ((fieldData.type !== 101 && fieldData.type !== 501) || fieldData.type !== classId) {
        return;
      }
      const objectInfo = this.$store.state.objectId;
      let insertBom = [];
      let obj = {
        'childId': fieldData.id,
        '1003001': fieldData.name,
        '1003003': '1',
        'itemId': objectInfo.id,
      };
      insertBom.push(obj)
      const { ...objInfo } = objectInfo;
      var change_info = this.$store.state.change_info;

      var updateBomData = {
        //post更改的值
        tableId: this.BOMsTableId,
        changeObjId: {
          id: change_info.changeId,
          classId: change_info.changeClassId,
          subClassId: change_info.changeSubClassId,
        },
        itemObjId: {
          id: objInfo.id,
          classId: objInfo.classId,
          subClassId: objInfo.subClassId,
          version: this.version,
        },
        insertBom: insertBom,
      };
      axios
        .post("/pmdm/items/saveTable", updateBomData)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getData();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    setAlteData(data) {

      var change_info = this.$store.state.change_info;
      let insertBom = [];
      const { rows } = data;

      const majorId = this.majorInfo.row.itemId;
      let length = (this.majorInfo.row.replaceItem || '').split(',').length + 1;

      rows.forEach((i, e) => {
        let obj = {
          'childId': i.objInfo.id,
          '1003001': i['pmdm_item-item_number'],
          '1003003': i.quantity,
          'itemId': this.$store.state.objectId.id,
          'text15': this.majorInfo.row.itemId,
          'multitext20': '替代组',
          '1003047': '2015_2',
          '1003062': length,

        };
        length++
        // if (systemName.indexOf('奥斯汀') != -1) {
        //   Object.assign(obj, { '1003078': i.department.join(';') })
        insertBom.push(obj)
      })
      var updateBomData = {
        //post更改的值
        tableId: this.BOMsTableId,
        changeObjId: {
          id: change_info.changeId,
          classId: change_info.changeClassId,
          subClassId: change_info.changeSubClassId,
        },
        itemObjId: {
          ... this.$store.state.objectId,
          version: this.version,
        },
        insertBom: insertBom,
      };

      axios
        .post("/pmdm/items/saveTable", updateBomData)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getData();
            // this.$refs.xGrid.revertData();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getDynamicData(row, columnIndex, column) {

      const nCol = this.gridOptions.columns[columnIndex + 1].uiType;
      const options = this.gridOptions.columns[columnIndex + 1].editRender.options;

      const val = row[column['field']];


      if (nCol === 3) {

        const obj = options.find(i => i.value === val || i.label === val)
        return !obj ? [] : [obj]
      } else {
        // return !val? [] : options.filter(i => val.includes(i.value)||val.includes(i.label) )
        if (!val) {
          return []
        } else {
          const list = val.map(i => {
            return options.find(j => i === j.value || i === j.label)
          })
          return list
        }
      }

    },
    // async

    editActivedEvent({ row, columnIndex, column }) {

      console.log(row, column);
      this.$store.commit('setPageChanged', { name: this.componentname, isChanged: true });

      const nCol = this.gridOptions.columns[columnIndex];
      console.log(nCol);
      if (nCol.listType === 3) {
        axios.get('pmdm/admin/list/getEnabledListEntryByListId?listId=' + nCol.listId).then(res => {
          nCol.editRender.options = res.data.object.listEntries.map(i => ({ value: i.listId + '_' + i.entryId, label: i.entryValue }))
        })
      }
    },


    clax(item) {
      axios.get('pmdm/admin/list/getObjectInfoByListId?listEntryId=' + item.value).then(res => {
        const obj = { ...res.data.object, title: item.label };
        this.getLink(obj);
        this.$store.commit('setPageRefresh');
      })
    },

    redLineSwitch() {

      if (this.switchValue) {
        this.getRedLineBOM()
      } else {
        this.getData();
      }

    },
    closeBOMList() {
      this.copyBOM = false;
      this.BOMListShow = false;
    },
    async getRedLineBOM() {
      const changeInfo = { ...this.$store.state.change_info }
      var obj = {
        ...this.objId,
        ...changeInfo,
        tableId: this.Global.redLineBomTableId,
      };
      const { data } = await this.$http.get(`/pmdm/items/loadTable${this.params(obj)}`);

      const { rows, columnInfo } = data.object.table;

      this.gridOptions.data = getNewRedLineTableContentData(rows, columnInfo);

    },
    checkboxChangeEvent({ records, row }) {
      const $grid = this.$refs.xGrid;
      this.selectRecords = records;
      $grid.setCurrentRow(row)
    },
    closeCreateNew() {
      this.creatNew = false;
      this.searchAddBom = false;
    },
    BOMCopy() {
      this.copyBOM = true;
      this.BOMTitle = this.titleList[2].title;
    },

    checkboxMethod({ row }) {
      console.log(row);

      const id = row?.itemId || row?.objectId?.id


      const arr = this.gridOptions.data.map(i => {
        console.log(i);

        const { itemId, objectId = {} } = i
        const { id: objId } = objectId

        const id = itemId || objId
        return id
      });
      // console.log(arr);

      return arr.includes(id)
      // return !row.hasParent;
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (row.redText) {
        for (var i = 0; i < row.redText.length; i++) {
          if (columnIndex == row.redText[i]) {
            return "col-red-text";
          }
        }
      } else if (row.redLine) {
        for (var i = 0; i < row.redLine.length; i++) {
          if (columnIndex == row.redLine[i]) {
            return "col-red";
          }
        }
      } else {
        return "";
      }
    },
    addM() {
      this.creatNew = true;
    },
    creatNewModel(e) {
      this.creatNew = false;
      this.searchAddBom = false;
      this.addList(e);
    },
    importBOM(file) {

      let fd = new FormData();

      const obj = {
        file: file,
        ...this.objectId,
        changeId: 0,
        changeClassId: 0,
        changeSubClassId: 0
      }
      for (const i in obj) {
        const e = obj[i];
        fd.append(i, e);
      }

      axios.post("/pmdm/import/importBom", fd).then(res => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.getData();
        }
      });
    },
    getExportedBOM(bom, level) {
      for (var i = 0; i < bom.length; i++) {
        let newBom = this.deepCopy(bom[i]);
        newBom[0] = level + newBom[0];
        this.exportedBom.push(newBom);
        if (bom[i].children != null) {
          this.getExportedBOM(bom[i].children, level + " | ");
        }
      }
    },
    expandAll() {


      // 对数据预处理
      // if (!this.switchValue) {
      // if (this.switchValue) {
      //   this.exportRedLineBOM();
      //   return;
      // }
      const changeInfo = this.get_change_info || this.$store.state.change_info;
      const itemId = this.$store.state.objectId.id;
      const { changeId, changeSubClassId } = changeInfo;
      var obj_get = {
        itemId,
        changeId,
        changeSubClassId,
        tableId: this.$store.state.boms_table_id
      };
      axios
        .get(`/pmdm/MultipleBom/loadMultipleBomTable${this.params(obj_get)}`)
        .then((res) => {

          const { rows, columnInfo } = res.data.object

          let arr = formatData({ rows, columnInfo });
          this.gridOptions.data = arr;

          const treeConfig = {
            children: "children",
            hasChild: "hasChildren",
            loadMethod: this.loadChildrenMethod,
          }
          this.$set(this.gridOptions, 'treeConfig', treeConfig);
          console.log(this.gridOptions);

        }).then(_ => {
          const runc = this.$refs.xGrid.setAllTreeExpand;
          runc(true)
          return
        })
    },
    // formatData({ rows, columnInfo }, level, parentRowId) {
    //   const newArr = getNewTableContentData(rows, columnInfo);
    //   console.log(newArr);


    //   return newArr;
    // },
    exportBOM() {

      // 对数据预处理
      // if (!this.switchValue) {
      if (this.switchValue) {
        this.exportRedLineBOM();
        return;
      }
      const changeInfo = this.get_change_info || this.$store.state.change_info;
      const itemId = this.$store.state.objectId.id;
      const { changeId, changeSubClassId } = changeInfo;
      var obj_get = {
        itemId,
        changeId,
        changeSubClassId,
        tableId: this.$store.state.boms_table_id
      };
      axios
        .get(`/pmdm/MultipleBom/loadMultipleBomTable${this.params(obj_get)}`)
        .then((res) => {
          const { rows } = res.data.object, columns = this.gridOptions.columns;
          let arr = this.getAllRow(this.getFormatData(res.data.object.rows));
          let data = arr.map((i, e) => {
            let obj = !e ? [this.$store.state.tabInfo.name, this.$store.state.tabInfo.description, i.serial] : ["", "", i.serial];
            // let obj =  ["","",i.serial];
            Object.keys(i).map(j => {
              if (Number(j) || j == 0) {
                obj.push(i[j])
              }
            })
            return obj;
          })

          const xx = this.gridOptions.columns.filter(i => i.type != 'checkbox').map(i => i.title)
          const column = ['父件编号', '父件描述', '序号', ...xx];

          data.unshift(column);

          // 转换数据
          let book = XLSX.utils.book_new();
          let sheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
          XLSX.utils.book_append_sheet(book, sheet);
          let wbout = XLSX.write(book, {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
          });
          let blob = new Blob([BOM_Methods.toBuffer(wbout)], {
            type: "application/octet-stream",
          });
          // 保存导出
          FileSaver.saveAs(blob, this.$t("message.title.BOMdoc"));
        });
    },

    exportRedLineBOM() {

      let arr = this.getAllRow(this.gridOptions.data);
      let data = arr.map((i, e) => {
        const label = !i.redlineType ? this.$t('message.title.add') : this.redLineTypeList.find(k => k.id == i.redlineType).label;
        // let obj =  [label,"","",e+1];
        let obj = !e ? [label, this.$store.state.tabInfo.name, this.$store.state.tabInfo.description, i.serial] : [label, "", "", i.serial];
        Object.keys(i).map(j => {
          if (Number(j) || j == 0) {
            obj.push(i[j])
          }
        })

        return obj;
      })

      const xx = this.gridOptions.columns.filter(i => i.type != 'checkbox').map(i => i.title)
      const column = ['', '父件编号', '父件描述', '序号', ...xx];
      data.unshift(column);

      // 转换数据
      let book = XLSX.utils.book_new();
      let sheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
      XLSX.utils.book_append_sheet(book, sheet);
      let wbout = XLSX.write(book, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });
      let blob = new Blob([BOM_Methods.toBuffer(wbout)], {
        type: "application/octet-stream",
      });
      // 保存导出
      FileSaver.saveAs(blob, this.$t("message.title.BOMdoc"));

    },
    setAlt() {
      const row = this.$refs.xGrid.getCurrentRecord();
      const col = this.gridOptions.columns;

      const e = col.findIndex(i => i.attid == 1003107);
      console.log(e, row[e]);

      if (row[e] == '替代物料') {
        this.$message.error('当前选项为替代料,请选择主料');
        return
      }

      console.log(this.$refs.xGrid.getCurrentRecord());
      if (!row) {
        this.$message.error('请选择主料');
        return
      }
      this.majorInfo = { row, col };
      this.getAlt = true
    },


    getExportData(isHead) {
      // this.getExportedBOM(this.gridOptions.data, "");
      this.getExportedBOM(this.exportDataTemp, "");

      let datas = this.exportedBom;
      this.exportedBom = [];
      let columns = this.gridOptions.columns;
      let headers = isHead ? [columns.map((item) => item.title)] : [];
      return headers.concat(
        datas.map((row) => {
          return columns.map((column) => {
            return row[column.field];
          });
        })
      );
    },

    noEdit({ row, column }) {
      if (column.editRender?.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions;
        let m = row[[column.property]];
        if (column.editRender.props.multiple) {
          this.cascaderValue = m ? m.map((i) => { return this.getParentIdList(this.cascaderList, i) }) : ''
          this.cascaderProps.multiple = true;
        } else {
          this.cascaderProps.multiple = false;
          this.cascaderValue = m;
        }
        this.cascaderProps.checkStrictly = true;
        this.tempData = { row, column }
        this.cascaderShow = true;
      }
    },
    customEvent({ type, $table }) {

      if (type != 'confirm') {
        return;
      }
      const currentColumns = $table.getColumns().map(i => i.property);
      const saveColumns = $table.tableFullColumn.filter(i => !currentColumns.includes(i.property)).map(i => i.property).join(';')
      let obj = {
        "baseId": 101,
        "clsId": 0,
        "subId": 0,
      };
      let seekVo = { ...obj, saveColumns, isPublic: 12, name: Date.now() + '' };
      this.seekId && Object.assign(seekVo, { id: this.seekId });

      axios.post("/search/advanced/saveSeek", { seekVo })
        .then(res => {
          this.seekId = res.data.object.result.id;
        })
        .catch(_ => { })
    },

    getCascadeValue() {
      let row = this.tempData['row']
      let column = this.tempData['column']

      if (column.editRender.props.multiple) {
        const valueList = this.cascaderValue.map(i => i[i.length - 1])
        const labelList = this.$refs['cascaderAddr'].presentTags    // 获取label值
        let currentOptions = [];
        valueList.map((i, e) => { currentOptions.push({ 'value': i, 'label': labelList[e].text }) })
        column.editRender.options = [...column.editRender.options, ...currentOptions];
        row[[column.property]] = valueList;
      } else {
        const value = this.cascaderValue[this.cascaderValue.length - 1];
        const label = this.$refs['cascaderAddr'].presentText;   // 获取label值
        column.editRender.options.push({ 'value': value, 'label': label });
        row[[column.property]] = value;
      }


      this.closeCascaderShow();
    },
    closeCascaderShow() {
      this.cascaderShow = false;
      this.cascaderValue = [];
    },
    removeCheckbox() {
      //删除
      this.$confirm(this.$t("message.confirm.deleteData"))
        .then((_) => {
          //done();
          var change_info = this.$store.state.change_info;
          //var removeRow = this.$refs.xGrid.removeCheckboxRow();
          var removeRow = this.$refs.xGrid.getCheckboxRecords();
          var del_table = [];

          if (removeRow.length == 0) {
            this.$message({
              message: this.$t("message.tips.dele_data"),
              type: "warning",
            });
            return false;
          } else {
            for (var i = 0; i < removeRow.length; i++) {
              var obj = {};
              obj.id = removeRow[i].rowId;
              obj.childId = removeRow[i].itemId;
              del_table.push(obj);
            }
            var delBomData = {
              tableId: this.BOMsTableId,
              changeObjId: {
                id: change_info.changeId,
                classId: change_info.changeClassId,
                subClassId: change_info.changeSubClassId,
              },
              itemObjId: {
                ... this.$store.state.objectId,

                version: this.version,
              },
              deleteBom: del_table,
            };
            axios
              .post("/pmdm/items/deleteTable", delBomData)
              .then(res => {
                if (res.data.code == 200) {
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.getData();
                  this.selectRecords = [];
                }
              })
              .catch(function (error) {
              });
          }
        })
        .catch((_) => { });

    },
    addList(row) {
      //添加
      if (row) {
        // this.searchAddBom = false;
        var change_info = this.$store.state.change_info;
        let insertBom = [];
        const systemName = window.sessionStorage.getItem("systemName");
        row.map((i, e) => {
          let obj = {
            'childId': i.id,
            '1003001': i.itemNumber,
            '1003003': i.quantity,
            'itemId': this.$store.state.objectId.id,
          };
          if (systemName.indexOf('奥斯汀') != -1) {
            Object.assign(obj, { '1003078': i.department.join(';') })
          }
          if (systemName.indexOf('dijing') != -1) {
            Object.assign(obj, { '1003002': (e + 1 + gridOptions.data.length), '1003007': 1 })
          }
          insertBom.push(obj)
        })
        var updateBomData = {
          //post更改的值
          tableId: this.BOMsTableId,
          changeObjId: {
            id: change_info.changeId,
            classId: change_info.changeClassId,
            subClassId: change_info.changeSubClassId,
          },
          itemObjId: {
            ... this.$store.state.objectId,
            version: this.version,
          },
          insertBom: insertBom,
        };

        axios
          .post("/pmdm/items/saveTable", updateBomData)
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              this.getData();
              // this.$refs.xGrid.revertData();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    closeSave() {
      // this.setPageChanged({ name: this.componentname, isChanged: false })
      this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
      this.getData();//不能用revertData（），会使getUpdateRecords（）拿不到正确的值。
      // this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
    },
    getUpdateEvent() {

      // 奥斯汀的特殊处理
      // 下面包括两部分：
      // 一部分是数量和生产单位不能为空，以后会开发BOM表的字段必填标准功能，这部分以后会去掉
      // 第二部分是替代组和替代关系的问题，要么都为空，要么都有值，这部分以后要一直保留
      let systemName = window.sessionStorage.getItem("systemName");

      if (systemName.indexOf('奥斯汀') != -1) {
        // 数量和生产单位不能为空
        let quantity = 0;
        let proUnit = 0;
        for (let k = 0; k < this.gridOptions.columns.length; k++) {
          if (this.gridOptions.columns[k].attid == this.Constants.itemBOMQty) {
            quantity = this.gridOptions.columns[k].field;
          }
          if (this.gridOptions.columns[k].attid == this.Constants.itemBOMMultilist01) {
            proUnit = this.gridOptions.columns[k].field;
          }
        }


        let allRows = this.$refs.xGrid.data;
        for (let i = 0; i < allRows.length; i++) {
          let oneRow = allRows[i];
          if (oneRow[quantity] == "" || oneRow[quantity] == null) {
            this.$message.error(this.$t("message.warning.blankRequired"));
            return false;
          }
          if (oneRow[proUnit] == "" || oneRow[proUnit] == null) {
            this.$message.error(this.$t("message.warning.blankRequired"));
            return false;
          }
        }
        let updateRecords = this.$refs.xGrid.getUpdateRecords();
        if (updateRecords[proUnit] != null && updateRecords[0] != null && !updateRecords[0][proUnit].length) {
          this.$message.error(this.$t("message.warning.blankRequired"));
          return false;
        }

        //替代组和替代关系的问题，要么都为空，要么都有值
        let substitutionalRelation = 0;
        let substituteTissue = 0;
        for (let k = 0; k < this.gridOptions.columns.length; k++) {
          if (this.gridOptions.columns[k].attid == this.Constants.itemBOMList02) {
            substitutionalRelation = this.gridOptions.columns[k].field;
          }
          if (this.gridOptions.columns[k].attid == this.Constants.itemBOMList01) {
            substituteTissue = this.gridOptions.columns[k].field;
          }
        }
        for (let i = 0; i < allRows.length; i++) {
          let oneRow = allRows[i];

          const subRelValueBlank = oneRow[substitutionalRelation] ?? '';
          const subTisValueBlank = oneRow[substituteTissue] ?? '';

          if (subRelValueBlank != subTisValueBlank) {
            this.$message.error(this.$t("message.warning.substituteTissueRelNotOneBlank"));
            return false;
          }
        }
      }


      var xGrid_ = this.$refs.xGrid;
      let updateRecords = this.$refs.xGrid.getUpdateRecords(); //获取修改的行
      var updateBom = [];
      if (updateRecords.length) {
        //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          // var num = xGrid_.getRowIndex(updateRecords[i]);
          var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            if (updateNewData) {

              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                var obj = {};
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  let props = this.gridOptions.columns[k].editRender.props
                  if (props) {
                    //处理多选和单选
                    if (props.multiple) {
                      // if (updateRecords[i][j] == null) {
                      //   obj[quantity] = "";
                      // } else {
                      //   obj[quantity] = updateRecords[i][j].join(";");
                      // }
                      obj[quantity] = updateRecords[i][j]?.join(";") ?? '';
                    } else if (
                      props.type == "datetime"
                    ) {
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(
                        updateRecords[i][j],
                        "yyyy-MM-ddThh:mm:ss"
                      );
                    } else {
                      obj[quantity] = updateRecords[i][j] ?? ''
                    }
                  } else {
                    obj[quantity] = updateRecords[i][j] ?? ''
                  }
                  updateBom.push(obj);
                }
              }
            }
          }
        }

        var change_info = this.$store.state.change_info;
        var updateBomData = {
          //post更改的值
          tableId: this.BOMsTableId,
          changeObjId: {
            id: change_info.changeId,
            classId: change_info.changeClassId,
            subClassId: change_info.changeSubClassId,
          },
          itemObjId: {
            ... this.$store.state.objectId,
            version: this.version,
          },
          updateBom: this.arrGroup(updateBom),
        };
        axios
          .post("/pmdm/items/updateTable", updateBomData)
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              this.getData();
              // xGrid_.revertData();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }

    },
    getFormatData(arr, level, parentRowId) {
      let newArr = [];
      let serial = level || "";
      parentRowId = parentRowId || "";
      arr.map((i, e) => {

        const s = e + 1 + "";
        let n = {
          rowId: i.rowId,
          parentRowId: !parentRowId ? i.rowId : parentRowId + ";" + i.rowId,
          grandParentSerial: !serial.includes(".") ? '' : serial.substring(0, serial.lastIndexOf('.')),
          serial: !serial ? s : serial + "." + s,
          parentSerial: serial
        };

        i.cells.map((j, e) => {
          const val = j?.val || ''
          Object.assign(n, { [this.gridOptions.columns[e + 1].field]: val })
        });
        newArr.push(n);
        n.children = !i.children ? [] : this.getFormatData(i.children, n.serial, n.parentRowId);
      });
      return newArr;
    },
    activeRowMethod({ row, columnIndex }) {
      console.log(row);

      if (this.editTable == false || row.cellDisable[Number(columnIndex - 1)] == false) {
        return false;
      };
      return true;
    },
    editDisabledEvent({ row, column }) {
      this.$message.error(this.$t("message.error.noEdit"));
    },
    editClick: function () {
      this.editShow = false;
    },
    showDetailEvent(row) {

      console.log(row);

      const { objectId } = row
      const obj = {
        ...objectId,
        title: row[0]
      };
      this.getLink(obj);
      this.$store.commit('setPageRefresh')
    },


    getListEntry(columnInfo, rows) {
      const { listIds, listTypes, uiTypes } = columnInfo;
      let listEntries = columnInfo.listEntries
      const rowList = rows.map(i => i.cells)
      rowList.map(i => {
        i.map((m, e) => {
          if (listTypes[e] === 3) {
            if (uiTypes[e] == 3 && m.val) {
              // listEntries[listIds[e]] = { [m.id]: m.val };

              listEntries[listIds[e]] = { ...listEntries[listIds[e]], [m.id]: m.val };
            }
            if (uiTypes[e] == 4 && m.ids) {
              // listEntries[listIds[e]] = {[i.id]:i.val};
              const ids = m.ids.split(';')
              const vals = m.val.split(';')
              const obj = {}
              ids.map((j, x) => {
                obj[j] = vals[x]
              })
              listEntries[listIds[e]] = { ...listEntries[listIds[e]], ...obj };
            }
          }
        })
      })

      let list = {};

      for (const i in listEntries) {
        const e = listEntries[i];
        list[i] = Object.entries(e).map(j => {
          const [value, label] = j
          return { value, label }
        })
      }
      return list
    },
    async getData() {
      this.$emit('refreshTab');
      this.BOMsTableId = this.$store.state.boms_table_id;
      this.BOMloading = true;
      var change_info = this.get_change_info || this.$store.state.change_info;

      var obj_get = {
        ... this.$store.state.objectId,
        ...change_info,
        tableId: this.BOMsTableId,

      };

      const { data } = await this.$http.get(`/pmdm/items/loadTable${this.params(obj_get)}`);
      const { rows, columnInfo, version } = data.object.table;
      this.version = version;

      const listEntries = this.getListEntry(columnInfo, rows);

      this.rols_text = getNewTableContentData(rows, columnInfo);
      let rowTitle = getNewTableTitleData(columnInfo);

      //uitype
      const ut = [0, ...columnInfo.uiTypes];

      for (let k = 1; k < rowTitle.length; k++) {
        //数字 金额 变窄
        if (this.smallWidthIds.includes(rowTitle[k].attid) || ut[k] == 7 || ut[k] == 10) {
          rowTitle[k].minWidth = 110;
        }
        if (rowTitle[k].listId != -1) {
          rowTitle[k].editRender.options = listEntries[[rowTitle[k].listId]]
        }

        if ([3, 4].includes(ut[k]) && rowTitle[k].listType === 3) {
          rowTitle[k].slots = {
            default: "getDynamic",
          };
        }
      }

      this.gridOptions.columns = rowTitle;
      const treeConfig = {
        lazy: true,
        children: "children",
        hasChild: "hasChildren",
        loadMethod: this.loadChildrenMethod,
      }
      this.$set(this.gridOptions, 'treeConfig', treeConfig);

      this.gridOptions.columns.map((item, index) => {

        const { attid: attrId } = item;

        if (LINK_LIST.includes(attrId)) {

          item.slots = {
            default: ({ row, column }, h) => {
              // 渲染链接
              return [
                <span
                  class="link_"
                  onClick={() => this.showDetailEvent(row, column)}
                >

                  {row[column.property]}
                </span>,
              ];
            },
          };
        }
      })
      this.cols = columnInfo.ids;
      // const tableContent = this.deepCopy(this.rols_text);

      this.departmentList = listEntries[10001] || listEntries[10008]
      this.gridOptions.data = this.rols_text;

      this.exportDataTemp = this.getNewChildrenTableContentData(data);

      this.oldTableValue = this.deepCopy(this.rols_text);
      this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
      this.BOMloading = false;

    },
    setColumns() {
      let n = this.gridOptions.columns
        .filter((i) => this.seekColumns.split(";").includes(i.field))
        .map((i) => {
          const column = this.$refs.xGrid.getColumnByField(i.field);
          this.$refs.xGrid.hideColumn(column);
        });
    },



    getTabBOMs() {
      axios.get("/pmdm/admin/getTab/" + this.$store.state.objectId.subClassId).then(
        res => {
          this.BOMList = !!(res.data.object.boms.length - 1);
        }
      )
    },
    getBOMList(e) {
      this.copyBOM = true;
      this.BOMListShow = true;
      this.BOMType = e;
      this.BOMTitle = this.titleList.find(i => i.id == e).title;
    },

    async loadChildrenMethod({ row }) {
      //获取子节点
      // 异步加载子节点
      var change_info = this.get_change_info || this.$store.state.change_info;
      const { itemId, itemClassId, itemSubClassId } = row;

      var obj_get = {

        id: itemId,
        classId: itemClassId,
        subClassId: itemSubClassId,
        changeId: row.changeId,
        changeClassId: change_info.changeClassId,
        changeSubClassId: change_info.changeSubClassId,
        tableId: this.BOMsTableId,
      };

      const { data } = await this.$http.get(`/pmdm/items/loadTable${this.params(obj_get)}`);

      const { columnInfo, rows } = data.object.table
      var table_content_text = this.mergeColumnInfo(
        this.gridOptions.columns,
        getNewTableTitleData(columnInfo),
        this.getNewChildrenTableContentData(data)
        // getNewTableContentData(rows, columnInfo)
      );

      // const { rows, columnInfo } = res.object.table;
      const listEntries = this.getListEntry(columnInfo, rows);
      console.log(listEntries);

      this.gridOptions.columns.map(i => {

        if (i?.listId && i.listId != -1 && listEntries[i.listId]) {
          console.log(i, i.listId);
          // i.editRender.options = [...i.editRender.options,...listEntries[i.listId]]
          const n = i.editRender.options.map(j => j.value);
          listEntries[i.listId].map(j => {
            if (!n.includes(j.value)) {
              i.editRender.options.push(j)
            }
          })
        }
      })

      for (var i in table_content_text) {
        //添加不可编辑
        this.childsTable.push(table_content_text[i]);
        table_content_text[i].hasParent = true;
      }
      var table_content_text_export = this.mergeColumnInfo(
        this.gridOptions.columns,
        getNewTableTitleData(columnInfo),
        //子节点所有值是只读，这个方法返回的multilist值是text形式展示
        this.getNewChildrenTableContentData(data)
      );
      this.setChildrenForExport(this.exportDataTemp, table_content_text_export, row.rowId);
      return table_content_text;
    },
    setChildrenForExport(BOMs, children, rowId) {
      for (var i in BOMs) {
        if (BOMs[i].rowId == rowId) {
          BOMs[i].children = children;
          break;
        }
        if (BOMs[i].children) {
          this.setChildrenForExport(BOMs[i].children, children, rowId)
        }
      }
    },

    loadUserPriv() {

      const isSuperAdmin = this.$store.state.isSuperAdmin;
      const privList = this.getUserContextPriv().filter(i => i.classId == this.$store.state.objectId.subClassId).map(j => j.type);
      this.addTableListPriv = isSuperAdmin || privList.includes(3);
      this.removeBtnPriv = isSuperAdmin || privList.includes(4);
      this.exportBtnPriv = isSuperAdmin || privList.includes(12);
    },

  },
  created() {

    const { changeInfoNum = '[{}]' } = this.$route.query;
    const arr = JSON.parse(changeInfoNum)
    this.editTable = arr.length == 1;

    this.getData();
    this.loadUserPriv();
    this.getTabBOMs();
    this.$nextTick(() => {
      this.setColumns();
    });
    this.redLine = this.$t("message.title.redLine"),
      setTimeout(() => {
        this.loading = false;
      }, 500);
  },
  props: ["changeValue"],
  watch: {
    "$store.state.setObjID": function (val) {
      //this.$router.push('/item')
      this.reload();
    },
    changeValue: function (value) {
      this.get_change_info = value;
      this.getData();
      // this.switchValue = true;
      this.switchValue = false;

    },
    "$store.state.boms_table_id": function (val) {
      this.getData();
    },
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from);
    const tabs = [...this.$store.state.showingTabsInHome];
    const activeName = this.$store.state.activedTabInHome;
    if (!this.$store.state.pageChanged) {//就是上面的状态 如果是true , 则不询问是否保存, 当然这个方法比较笨, 大家可以使用更优雅的方式
      next();
    } else {

      this.$confirm("当前页面有未保存信息，确定离开么", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
          next();
          if (to.path == from.matched[1].path) {
            this.$store.commit("setPageRefresh");
          }
        })
        .catch(() => {
          this.$store.commit("replaceShowingTabsInHome", tabs);
          this.$store.commit("setActivedTabInHome", activeName);
        });
    }
  },
};
</script>

<style>
.searchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.searchAddBomList .el-carousel__container {
  height: 450px !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}

.mytable-style .vxe-body--column.col-red {
  text-decoration: line-through;
  color: red;
}

.mytable-style .vxe-body--column.col-red span {
  color: #000;
}

.mytable-style .vxe-body--column.col-red-text {
  color: red;
}

.mytable-style .vxe-body--column.col-red-text span {
  color: red;
}
</style>
<style scoped>
.showLink {
  color: #4b92ff;
  cursor: pointer;
  text-decoration: underline;
  margin-right: 3px;
}

.icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
}
</style>